<template>
<div class="track">
  <div class="track-top">
    <h2>{{track.topic}}</h2>
    <span>
      会议室：{{track.address?track.address:'待定'}}
      <small v-if="$store.state.info.displayPresentationTime">时间：{{presentationTime?presentationTime:'待定'}}</small>
    </span>
    <h6 v-if="track.speaker && track.speaker.name">出品人：{{track.speaker.name}}</h6>
    <div v-if="fullDescription || !cutDescription" class="content" v-html="track.description"></div>
    <div v-else class="content">
      <p><span v-html="cutDescription"></span>... <a class="more" @click="fullDescription=true">展开 ></a></p>
    </div>
  </div>

  <!-- <div class="tabs">
    <div class="tab" :class="{active: curTab==='presentation'}" @click="curTab='presentation'">
      <a>旗下议题</a>
    </div>
    <div class="tab" :class="{active: curTab==='speaker'}" @click="curTab='speaker'">
      <a>出品人介绍</a>
    </div>
  </div> -->

  <div class="track-bottom">
    <div class="presentation main-topic">
      <template v-if="trainings.length">
        <ul>
          <li v-for="(presentation, index) in trainings" :key="index" v-if="Number(presentation.id) !== 152">
            <div class="schedule-time">Topic {{index+1}}
            </div>
            <router-link class="schedule-detail" :to="'/training/' + presentation.id">
              <span class="arrow arrow_l_int"></span>
              <span class="arrow arrow_l_out"></span>
              <div class="title">{{presentation.title}}</div>
              <div class="bottom">
                <div class="speaker" v-for="(sid, idx) in presentation.speakerIds" :key="idx" :class="presentation.speakerIds.length>1?'multi':''" v-if="speakers[sid]">
                  <img :src="speakers[sid].avatar" />
                  <div class="right">
                    <h4>{{speakers[sid].name}}</h4>
                    <small>{{speakers[sid].company}}&nbsp;{{speakers[sid].position}}</small>
                  </div>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </template>
      <template v-else>
        <div class="smile">
          <img src="./assets/smile.png"/>
          <h6 >更多技术大牛邀请中</h6>
        </div>
      </template>
    </div>
    <!-- <div class="speaker" v-show="curTab==='speaker'">
      <template v-if="track.speaker && track.speaker.name">
        <speaker :speaker-config="speakerConfig" :speaker="track.speaker"></speaker>
      </template>
      <template v-else>
        <div class="smile">
          <img src="./assets/smile.png"/>
          <h6 >更多技术大牛邀请中</h6>
        </div>
      </template>
    </div> -->
  </div>
</div>
</template>

<script>
// import Speaker from '../com-speaker'
import moment from 'moment'

export default {
  data () {
    return {
      curTab: 'presentation', // presentation, speaker
      fullDescription: false
    }
  },
  components: {
    // Speaker
  },
  props: [
    'id'
  ],
  computed: {
    track () {
      return this.$store.state.topics[this.id] || { lectureIds: [], description: '', speaker: {} }
    },
    trainings () {
      return this.track.lectureIds.map(id => this.$store.state.lectures[id])
    },
    speakers () {
      return this.$store.state.speakers
    },
    speakerConfig () {
      return this.$store.state.speakerConfig
    },
    presentationTime () {
      return moment(this.track.time).utcOffset('+08:00').format('MM月DD日 hh:mm')
    },
    cutDescription () {
      // return this.track.description.replace(/<[^>]+>/g, '').replace(/\s+/g, '').slice(0, 40)
      return this.track.description.replace(/^<[^>]+>/g, '').slice(0, 40)
    }
  },
  mounted () {
    this.curTab = this.trainings.length ? 'presentation' : 'speaker'
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>

<style lang="sass">
.track-top
  padding-bottom: 57px
  background: url('./assets/trackbg.png')no-repeat right bottom
  background-color: var(--primary-color)
  background-size: 100% auto
  h2
    font-size: 22px
    text-align: center
    padding: 36px 27px 0 27px
    color: #fff
  span
    display: block
    margin-top: 8px
    font-size: 13px
    text-align: center
    color: $grey-lighter
    small
      padding-left: 12px
      font-size: 13px
  a.more
    margin-left: 10px
    color: $grey-lighter
  h6
    margin-top: 16px
    font-size: 13px
    text-align: center
    color: #fff
  p
    margin-top: 20px
    padding: 0 27px
    text-align: justify
    line-height: 24px
    color: #fff
    font-size: 14px
    color: #fff
    span
      display: inline

.tabs
  display: flex
  height: 64px
  .tab
    flex-grow: 1
    flex-basis: 0
    display: flex
    justify-content: center
    align-items: center
    border-bottom: 1px solid var(--primary-color)
    height: 100%
    cursor: pointer
    &.active
      border-bottom: 5px solid var(--primary-color)

.smile
  background-color: #f3f3f3
  padding: 100px 0
  display: flex
  flex-direction: column
  align-items: center
  > img
    width: 55px
  h6
    font-size: 14px
    color: #898989
    margin-top: 25px

.presentation
  background-color: #f3f3f3
  padding: 20px 15px
  li
    display: flex
    align-items: flex-start
    margin-top: 18px
    justify-content: space-between
    .schedule-time
      position: relative
      flex-shrink: 0
      width: 60px
      padding: 4px 0
      border-radius: 4px
      font-size: 14px
      text-align: center
      color: #fff
      background-color: rgba(var(--primary-rgb-color), 0.7)
    .schedule-detail
      display: block
      background-color: #f7f7f7
      flex-grow: 1
      position: relative
      margin-left: 12px
      padding: 5px 14px
      border: 1px solid rgba(var(--primary-rgb-color), 0.7)
      .arrow
        display: block
        border: 6px solid transparent
        position: absolute
        top: 8px
        left: -13px
        border-color: transparent rgba(var(--primary-rgb-color), 0.7) transparent  transparent
      .arrow_l_out
        border-color: transparent #fff transparent transparent
        left: -12px
      .title
        font-size: 15px
        color: #3e3a39
      .bottom
        margin-top: 6px
        .speaker
          display: flex
          align-items: center
          &.multi
            margin-top: 4px
            &:first-child
              margin-top: 0
            img
              width: 45px
              height: 45px
          img
            width: 55px
            height: 55px
            border-radius: 50%
            border: 1px solid #dcdddd
          .right
            flex-grow: 1
            margin-left: 10px
            h4
              font-size: 15px
              color: var(--primary-color)2
            small
              font-size: 12px
              color: #898989

</style>
